"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encode_json = exports.decode_json = void 0;
function decode_json(text) {
    if (text === null || text === undefined)
        return undefined;
    try {
        return JSON.parse(text);
    }
    catch (e) {
        return undefined;
    }
}
exports.decode_json = decode_json;
function encode_json(json) {
    return JSON.stringify(json);
}
exports.encode_json = encode_json;
